import { render, staticRenderFns } from "./companyResearch.vue?vue&type=template&id=a181935e&scoped=true"
import script from "./companyResearch.vue?vue&type=script&lang=js"
export * from "./companyResearch.vue?vue&type=script&lang=js"
import style0 from "./companyResearch.vue?vue&type=style&index=0&id=a181935e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a181935e",
  null
  
)

export default component.exports